import React, { ComponentType } from 'react';

import AuthLayout from 'layouts/Auth/Auth';

export const withAuthLayout =
  <T,>(Component: ComponentType<T>) =>
  (props: T): JSX.Element =>
    (
      <AuthLayout>
        <Component {...props} />
      </AuthLayout>
    );
